// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".w-e-text ol,.w-e-text ul{margin-left:40px}", ""]);
// Exports
module.exports = exports;
